

















import mixins from 'vue-typed-mixins';
import NotificationUtils, { Notification } from '@/utils/NotificationUtils';
export default mixins().extend({
  computed: {
    headers(): any {
      return [
        { text: this.$tc('model.notification.name'), value: 'name' },
        {
          text: this.$tc('model.notification.datepublished'),
          value: 'datepublished',
        },
      ];
    },
  },

  data(): {
    items?: Notification[];
  } {
    return {
      items: undefined,
    };
  },

  async mounted() {
    try {
      this.items = await NotificationUtils.api.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async create() {
      await this.$router.push({
        name: 'notification-create',
      });
    },

    async edit(item: Notification) {
      await this.$router.push({
        name: 'notification-edit',
        params: { id: `${item.id}` },
      });
    },

    async remove(item: Notification) {
      try {
        await this.$confirm(
          this.$i18n
            .t('validation.confirmation.delete', [item.name])
            .toString(),
          async () => {
            if (item.id && this.items) {
              await NotificationUtils.api.remove(item.id);

              this.$toast.push({
                type: 'success',
                text: this.$languageobj('validation.success.delete', {
                  values: [item.name],
                }),
              });

              const index = this.items.findIndex((val) => val.id === item.id);
              if (index >= 0) {
                this.items.splice(index, 1);
              }
            }
          }
        );
      } catch (error) {
        this.$alert.show('remove', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
